import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/news/news-icon.svg'
import _imports_1 from '@/assets/news/news-text.svg'


const _withScopeId = n => (_pushScopeId("data-v-ef505456"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "ad-unit-news" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "icon",
      src: _imports_0
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "icon-text",
      src: _imports_1
    })
  ])
], -1))
const _hoisted_3 = { class: "latest-news" }
const _hoisted_4 = { class: "more-news" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_news_card = _resolveComponent("news-card")!
  const _component_common_section = _resolveComponent("common-section")!
  const _component_layout_footer = _resolveComponent("layout-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.pageReady)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "news-container",
          style: _normalizeStyle(_ctx.cssProps)
        }, [
          _hoisted_2,
          (_ctx.trendingNews != undefined)
            ? (_openBlock(), _createBlock(_component_news_card, {
                key: 0,
                class: "news-card max-width",
                type: "description",
                label: _ctx.t('news.just-in'),
                news: _ctx.trendingNews
              }, null, 8, ["label", "news"]))
            : _createCommentVNode("", true),
          _createVNode(_component_common_section, {
            class: "c-section",
            text: _ctx.t('news.latest-news'),
            colorLeft: _ctx.mainColor,
            colorRight: _ctx.secondaryColor
          }, null, 8, ["text", "colorLeft", "colorRight"]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.latestNews, (news) => {
              return (_openBlock(), _createBlock(_component_news_card, {
                key: news.id,
                class: "news-card max-width",
                type: "description",
                news: news
              }, null, 8, ["news"]))
            }), 128))
          ]),
          _createVNode(_component_common_section, {
            class: "c-section",
            text: _ctx.t('news.more-news'),
            colorLeft: _ctx.mainColor,
            colorRight: _ctx.secondaryColor
          }, null, 8, ["text", "colorLeft", "colorRight"]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moreNews, (news) => {
              return (_openBlock(), _createBlock(_component_news_card, {
                key: news.id,
                type: "row",
                news: news,
                class: "more-news-row"
              }, null, 8, ["news"]))
            }), 128))
          ]),
          _createVNode(_component_layout_footer, { spot: _ctx.adSpotFooter }, null, 8, ["spot"])
        ], 4))
      : _createCommentVNode("", true)
  ], 64))
}